import { AxiosError } from 'axios';
import { useQuery, UseQueryOptions } from 'react-query';
import { Axios } from '@utils/api/axios-instance';
import { BaseError } from '@utils/types/shared/base';
import { GET_URL_NEW } from '@utils/api/endpoints';
import { QueryKeys } from '@utils/api/query-keys';
import { useNewAppSearchParams } from '@utils/hooks/use-new-app-search-params';
import { ExportTemplateResponse } from '@utils/types/organization/export-template';

export const useGetExportBoTemplates = (
  customerId: number,
  options?: UseQueryOptions<
    ExportTemplateResponse,
    AxiosError<BaseError>,
    ExportTemplateResponse
  >
) => {
  const { searchParams } = useNewAppSearchParams();

  const offset = Number.isFinite(Number(searchParams.offset))
    ? Number(searchParams.offset)
    : 0;
  const limit = Number.isFinite(Number(searchParams.limit))
    ? Number(searchParams.limit)
    : 25;

  const sortField = (searchParams.sort as string | undefined) || undefined;
  const sortDirection =
    (searchParams.direction as 'asc' | 'desc' | undefined) || undefined;

  const qString = (searchParams.q as string | undefined) || undefined;

  const fetchTemplates = async () => {
    const { exportTemplatesByCustomerId } = GET_URL_NEW({
      offset,
      limit,
      q: qString,
      sort: sortField,
      direction: sortDirection
    });

    const url = exportTemplatesByCustomerId(customerId);
    const { data } = await Axios.get<ExportTemplateResponse>(url);
    return data;
  };

  return useQuery<ExportTemplateResponse, AxiosError<BaseError>>(
    [
      ...QueryKeys.exportTemplates(),
      customerId,
      offset,
      limit,
      qString,
      sortField,
      sortDirection
    ],
    fetchTemplates,
    { useErrorBoundary: false, keepPreviousData: true, ...options }
  );
};
